import RAdmin from './admin.routes'
import RFSOfficer from './fso.routes'
import RASManager from './asm.routes'
import RShared from './shared.routes'
import RRSManager from './rsm.routes'
import RMKOfficer from './mkm.routes'
import RAudit from './audit.routes'
import RAccountant from './accountant.routes'

const allRoutes = []

export default allRoutes.concat(
  RAdmin,
  RShared,
  RFSOfficer,
  RASManager,
  RRSManager,
  RMKOfficer,
  RAudit,
  RAccountant
)
